import React from 'react';
import {array, bool, func, string} from 'prop-types';
import MediaCard from '../MediaCard';

const UploadFiles = (props) => {
  return (
    <div>
      <li id="uploader" className="sda-card-upload shuffle-item filtered">
        <div className="card-body">
          <div className="sda-file-uploader-inner">
            drag files here!
            <br />
            <small>or</small>
            <br />
            <div className="admin-btn">select files</div>
          </div>
        </div>
        <input
          type="file"
          name="file"
          className="media-file-attach-input"
          accept="image/*,video/*"
          capture multiple
        />
      </li>

      {props.uploadedAssets.map((data, index) =>
        <MediaCard
          key={index}
          data={data}
          viewStyle={props.viewStyle}
          checkComponentBox={props.checkComponentBox}
          mediaClickHandler={props.mediaClickHandler}
          isCheckable={() => props.isCheckable}
        />)}

    </div>
  );
};

UploadFiles.propTypes = {
  isCheckable: bool,
  uploadedAssets: array,
  checkComponentBox: func,
  mediaClickHandler: func,
  viewStyle: string,
};

export default UploadFiles;
